
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#363636","stroke-width":"0px"},attrs:{"d":"m47.19,0h-30.36C7.54,0,0,6.2,0,13.84v35.64c0,8.02,7.9,14.52,17.66,14.52h29.53c9.29,0,16.83-6.18,16.81-13.82V13.82c0-7.64-7.52-13.82-16.81-13.82Zm13.81,50.18c0,3.06-1.58,5.3-2.92,6.64-2.65,2.66-6.62,4.18-10.89,4.18h-29.53c-8.08,0-14.66-5.17-14.66-11.52V13.84c0-5.98,6.2-10.84,13.83-10.84h30.36c7.61,0,13.81,4.85,13.81,10.82v36.36Zm-36.88-3.37h-.22c-.85-.06-1.63-.49-2.15-1.17l-7.68-10.12c-.79-1.05-.59-2.53.46-3.33,1.04-.79,2.53-.59,3.33.46l6.46,8.52,23.09-22.63c.94-.92,2.44-.9,3.36.03.92.94.9,2.44-.03,3.36l-24.53,24.04c-.56.55-1.31.85-2.08.85h0Z"}})])
          )
        }
      }
    